import { dialog } from "../../nq-component";
import InputFactory from "../InputFactory";
import { useEffect, useState } from "react";

function DialogCreate({
  onSubmit,
  onChangeModal,
  onSubmitModal,
  collection,
  field,
  placeholder,
}) {
  const [object, setObject] = useState({});

  const onCancel = () => {
    dialog.close();
  };

  const _onChangeModal = (value, field) => {
    setObject({ [field]: value });
  };

  const _onSubmitModal = (e) => {
    e.preventDefault();
    onSubmitModal(collection, object);
  };

  return (
    <div className="p-3">
      <div className="d-flex flex-column">
        <b className="fs-4" style={{ borderBottom: "1px solid black" }}>
          Add
        </b>
        <form
          onSubmit={(e) => {
            _onSubmitModal(e);
          }}
        >
          <div className="d-flex flex-column my-2 gap-2">
            <label className="fw-bold">{field}</label>
            <InputFactory
              type="text"
              placeholder={placeholder}
              field={"name"}
              onChange={_onChangeModal}
            />
            <div className="d-flex gap-2">
              <button
                className="btn btn-secondary card"
                onClick={() => onCancel()}
              >
                Cancel
              </button>
              <button
                disabled={Object.keys(object).length === 0}
                className="btn btn-primary"
                style={{ backgroundColor: "#14213D" }}
              >
                Submit
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}

export default DialogCreate;
